import {
  Component, ContentChild,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  styler,
  register,
  APPLY_STYLES_TYPE
} from "@wm/components-base";
import {FormComponent} from "../../../../widgets/data/form/form.component";

const DEFAULT_CLS = 'app-login app-form app-login-form';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-login',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'div[wmLogin]',
  template: `<p wmMessage class="app-login-message" #message show.bind="loginMessage.show" caption.bind="loginMessage.caption" type.bind="loginMessage.type"></p>
  <ng-content></ng-content>`,
  providers: [
    provideAsWidgetRef(LoginComponent)
  ],
  exportAs: 'wmLogin',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class LoginComponent extends StylableComponent {
  static initializeProps = register('wm-login');



  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }

}

